'user strict'
const ex = require('../lib/error')
const jwt = require('jsonwebtoken')
const sequelize = require('sequelize')
const userTokens = require('../models').userTokens

const createUserToken = (req, res, next) => {

  // save in databse if OTP exists/generated
  if(req.responseObject.data.hasOwnProperty("otp")) {

    userTokens.create(req.responseObject.data)
    .then(token => {
      req.responseObject.messageCode = 'MAUD001'
      req.responseObject.data = token
      next()
    })
    .catch(error => {
      let errCode
      if (error.name === 'SequelizeUniqueConstraintError') {
        errCode = 'MAUD003' 
      } else {
        errCode = 'MAUD004'
      }
      ex.raiseError(req, res, errCode, 500, error)
    })
  } else {
    next();
  }
}

const verifyOTP = (req, res, next) => {

  if(!req.body || !req.body.mobileNo || !req.body.otp || req.body.mobileNo.length !== 10 || req.body.otp.length !== 6) {
    ex.raiseError(req, res, "Invalid Mobile No. or OTP", 400, "Invalid Mobile No. or OTP")
  } else {
    
    const where = {
      mobileNo: req.body.mobileNo,
      otp: req.body.otp,
      [sequelize.Op.and]: [sequelize.where(
        sequelize.fn(
            'TIMESTAMPDIFF',
             sequelize.literal("SECOND"),
             sequelize.col('createdAt'),
             sequelize.literal('UTC_TIMESTAMP')
        ),
        {
            [sequelize.Op.lte] : 600
        }
      )]
    }
    userTokens
      .findOne({where:where , order: [['createdAt', 'DESC']]})
      .then(token => {
      if(token == null){
          ex.raiseError(req, res, "Failed to verify OTP", 400, "Failed to verify OTP")
      }else{
          next()
      }
      })
      .catch(error => {
        let errCode
        errCode = 'MAUD006'
        ex.raiseError(req, res, errCode, 500, error)
      })
  }
}

module.exports = {
    createUserToken,
    verifyOTP
}